import { jsxs as M, jsx as _ } from "react/jsx-runtime";
import { useRef as F, useState as N, useMemo as W, useCallback as w, useEffect as A } from "react";
import { V as k } from "./index-Dlw4JYvo.js";
import { c as v } from "./clsx-OuTLNxxd.js";
import { B as H } from "./Button-D6KC5041.js";
import './TableScrollContainer.css';const V = 600, D = ({ cellWidth: C, maxRows: p }) => {
  const d = F(null), [a, c] = N(0), [T, B] = N(!1), [l, j] = N({
    pinCount: 0,
    rowCount: 0,
    headings: null
  }), [S, m] = N({
    top: !1,
    bottom: !1,
    left: !1,
    right: !1
  }), e = W(
    () => S.left || S.right,
    [S.left, S.right]
  ), i = w(() => {
    if (!d.current) return null;
    const t = d.current.querySelector("table"), o = d.current.getElementsByTagName("thead")[0], n = d.current.getElementsByTagName("tbody")[0], u = d.current.getElementsByTagName("tfoot")[0];
    if (!t || !o) return null;
    const s = o.getElementsByTagName("th");
    return s.length ? { container: d.current, table: t, headings: s, tbody: n, tfoot: u } : null;
  }, []), h = w(() => {
    var f;
    const t = i();
    if (!t) return;
    const { headings: o, tbody: n } = t, u = ((f = n == null ? void 0 : n.getElementsByTagName("tr")) == null ? void 0 : f.length) || 0, s = T ? 0 : [...o].filter((g) => g.dataset.pinned === "true").length;
    j({
      pinCount: s,
      rowCount: u,
      headings: o
    });
  }, [i, T]), y = w(() => {
    const t = i();
    if (!t) return { left: !1, right: !1 };
    const { container: o, table: n } = t, u = o.clientWidth, s = n.clientWidth, f = a >= 0, g = a <= -(s - u);
    return {
      left: !f,
      right: !g && s > u
    };
  }, [a, i]), E = w(() => {
    if (!l.headings)
      return { top: !1, bottom: !1 };
    const t = i();
    if (!t || !t.tbody || !t.tfoot)
      return { top: !1, bottom: !1 };
    const { tbody: o, tfoot: n } = t, u = l.headings[0].getBoundingClientRect().bottom, s = n.getBoundingClientRect().top, f = o.getBoundingClientRect().top, g = o.getBoundingClientRect().bottom;
    return {
      top: f < u,
      bottom: g > s
    };
  }, [i, l.headings]), b = w(
    (t = !1) => {
      const o = y();
      if (t) {
        const n = E();
        m({
          ...o,
          ...n
        });
      } else
        m((n) => ({
          ...n,
          ...o
        }));
    },
    [y, E]
  ), z = w(
    (t) => {
      const o = i();
      if (!o) return;
      const { container: n, table: u } = o, s = n.clientWidth, f = u.clientWidth, g = Math.max(0, f - s), x = t === "left" ? Math.min(0, a + C) : Math.max(-g, a - C);
      c(x), b();
    },
    [C, b, a, i]
  );
  return A(() => {
    B(window.innerWidth <= V), h();
    const t = !!p && !!l.rowCount && p < l.rowCount;
    b(t);
    const o = () => {
      B(window.innerWidth <= V), h(), b(!!p);
    };
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o);
    };
  }, [p, b, h, l.rowCount]), {
    scrollRef: d,
    currentTransform: a,
    scrollDirection: S,
    shouldShowScrollButtons: e,
    pinCount: l.pinCount,
    onScrollClick: z,
    checkScroll: b,
    rowCount: l.rowCount
  };
}, I = "_wrapper_1jeb2_32", L = "_captionWrapper_1jeb2_41", O = "_caption_1jeb2_41", $ = "_buttonWrapper_1jeb2_58", q = "_button_1jeb2_58", K = "_innerWrapper_1jeb2_72", P = "_hasMaxHeight_1jeb2_78", X = "_hasScrollShadowEnd_1jeb2_82", G = "_hasScrollShadowStart_1jeb2_91", J = "_hasScrollShadowTop_1jeb2_100", Q = "_hasScrollShadowBottom_1jeb2_109", R = "_hasVerticalScroll_1jeb2_126", U = "_hasHorizontalScroll_1jeb2_130", Y = "_scrollFullWidth_1jeb2_134", r = {
  wrapper: I,
  captionWrapper: L,
  caption: O,
  buttonWrapper: $,
  button: q,
  innerWrapper: K,
  hasMaxHeight: P,
  hasScrollShadowEnd: X,
  hasScrollShadowStart: G,
  hasScrollShadowTop: J,
  hasScrollShadowBottom: Q,
  hasVerticalScroll: R,
  hasHorizontalScroll: U,
  scrollFullWidth: Y
}, rt = ({
  caption: C,
  cellWidth: p = 60,
  children: d,
  className: a,
  maxRows: c,
  ...T
}) => {
  const {
    checkScroll: B,
    currentTransform: l,
    onScrollClick: j,
    pinCount: S,
    rowCount: m,
    scrollDirection: e,
    scrollRef: i,
    shouldShowScrollButtons: h
  } = D({
    maxRows: c,
    cellWidth: p
  }), y = W(
    () => v(
      r.wrapper,
      {
        [r.hasScrollShadowTop]: e.top,
        [r.hasScrollShadowBottom]: e.bottom,
        [r.scrollFullWidth]: !e.left || !h,
        [r.hasVerticalScroll]: e.top || e.bottom,
        [r.hasHorizontalScroll]: e.left || e.right
      },
      a
    ),
    [a, e, h]
  ), E = W(
    () => v(r.innerWrapper, {
      [r.hasMaxHeight]: c,
      [r.hasScrollShadowEnd]: h && e.right,
      [r.hasScrollShadowStart]: h && e.left
    }),
    [c, h, e.right, e.left]
  ), b = W(
    () => ({
      "--maxRows": m && c && m < c ? m : c,
      "--cellWidth": `${p}px`,
      "--pinCount": S
    }),
    [p, c, S, m]
  ), z = W(
    () => ({
      "--table-horizontal-offset": `translateX(${l}px)`
    }),
    [l]
  );
  return /* @__PURE__ */ M("div", { className: y, style: b, ...T, children: [
    /* @__PURE__ */ M("div", { className: r.captionWrapper, children: [
      /* @__PURE__ */ _("h2", { className: r.caption, children: C }),
      h && /* @__PURE__ */ M("div", { className: r.buttonWrapper, "data-testid": "scroll-controls", children: [
        /* @__PURE__ */ _(
          H,
          {
            "aria-label": "scroll table left",
            className: r.button,
            disabled: !e.left,
            onClick: () => j("left"),
            variant: "ghost",
            children: /* @__PURE__ */ _(k, { size: "s" })
          }
        ),
        /* @__PURE__ */ _(
          H,
          {
            "aria-label": "scroll table right",
            className: r.button,
            disabled: !e.right,
            onClick: () => j("right"),
            variant: "ghost",
            children: /* @__PURE__ */ _(k, { size: "s" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ _(
      "div",
      {
        className: E,
        onScroll: () => B(!!c),
        ref: i,
        style: z,
        children: d
      }
    )
  ] });
};
export {
  rt as T
};
